import initialLeagueList from '../config/initialLeagueList'

export default function findInitialLeague(sportsMap) {
  for (const sportAndLeague of initialLeagueList) {
    const { sport, league } = sportAndLeague

    if (sportsMap.has(sport) && sportsMap.get(sport).has(league)) {
      return { group: 'All Sports', sport, league }
    }
  }

  if (sportsMap.has('Soccer')) {
    const leaguesMap = sportsMap.get('Soccer')

    let maxLeague = null
    let maxEvents = -1

    leaguesMap.forEach((numberOfEvents, leagueName) => {
      if (numberOfEvents > maxEvents) {
        maxEvents = numberOfEvents
        maxLeague = { group: 'All Sports', sport: 'Soccer', league: leagueName }
      }
    })

    if (maxLeague) {
      return maxLeague
    }
  }

  return { group: 'Favorites', sport: null, league: 'Favorites' }
}